import { Component, OnInit, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {
  title: string;
  message: string;
  deleteType: string;
  button1Name: string;
  button2Name: string;
  managerComments: string;
  submitted = false;

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel) {
    dialogRef.disableClose = true;
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
    this.deleteType = data.deleteType;
    if (this.deleteType == "Record") {
      this.button1Name = "Delete";
      this.button2Name = "Cancel";
    }
    else if (this.deleteType == "Attachment") {
      this.button1Name = "Remove";
      this.button2Name = "Cancel";
    }
    else if (this.deleteType == "Submit") {
      this.button1Name = "Yes";
      this.button2Name = "No";
    }
    else if (this.deleteType == "Manager") {
      this.button1Name = data.title;
      this.button2Name = "Cancel";
    }
  }

  ngOnInit() {
  }

  onConfirm(): void {
    if (this.deleteType == "Manager") {
      this.submitted = true;
      if (this.managerComments != null && this.managerComments != "" && this.managerComments.trim() != '') {
        this.dialogRef.close({event:true,data:this.managerComments})
      }
    }
    else
      this.dialogRef.close(true);
  }

  onDismiss(): void {
    if (this.deleteType == "Manager") {
      this.dialogRef.close({ event: false})
    }
    else
      this.dialogRef.close(false);
  }
}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class ConfirmDialogModel {

  constructor(public title: string, public message: string, public deleteType: string, public button1Name?: string, public button2Name?: string) {
  }
}

